<div>
    <mat-tab-group #tabGroup mat-stretch-tabs="false">
        <mat-tab label="Controller Software">
            <div class="flex-center">
                <div class="row softwarereleasetofield">
                    <div class="edituser col-md-3 col-sm-12">
                        <software-release-levels (onLevelSelectedTrigger)="onControllerLevelSelected($event)">
                        </software-release-levels>
                    </div>
                    <div class="softwarereleases col-md-9 col-sm-12">
                        <software-release-list [familyCodes]="familyCodes"
                                               [softwareReleases]="controllerSoftwareReleases"
                                               (saveSuccess)="onSoftwareReleaseListSaved()"></software-release-list>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Peripheral Software">
            <div class="flex-center">
                <div class="row softwarereleasetofield">
                    <div class="edituser col-md-3 col-sm-12">
                        <software-release-levels (onLevelSelectedTrigger)="onPeripheralLevelSelected($event)">
                        </software-release-levels>
                    </div>
                    <div class="softwarereleases col-md-9 col-sm-12">
                        <software-release-list [familyCodes]="familyCodes"
                                               [softwareReleases]="peripheralSoftwareReleases"
                                               [isPeripheral]="true"
                                               (saveSuccess)="onSoftwareReleaseListSaved()"></software-release-list>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
